import { render, staticRenderFns } from "./ProspectParticuliers.vue?vue&type=template&id=b164a558&"
import script from "./ProspectParticuliers.vue?vue&type=script&lang=js&"
export * from "./ProspectParticuliers.vue?vue&type=script&lang=js&"
import style0 from "./ProspectParticuliers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports